import { useContext } from "react";
import { PageContext } from "../contexts/PageContext";
import { useParams } from "react-router-dom";
import { Box, useTheme } from "@mui/material";
import ModelEditPanel from "../panels/ModelEditPanel";

export function ModelsView() {
  const { modelId } = useParams<{ modelId: string }>();
  const theme = useTheme();
  const { isLoggedIn, user } = useContext(PageContext);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        backgroundColor: theme.palette.background.default,
        color: "#ECECEC",
        overflow: "hidden",
        px: 0, // Padding shorthand
        py: 0, // Padding shorthand
      }}
    >
      <ModelEditPanel selectedModelId={modelId === 'new' ? '' : (modelId || 'new')} rendererKey={'Date.now().toString()'} />"
    </Box>
  );
}
